/*! TWire JS helper functions - MIT license */
import util   from './twire.util';
import forms  from './twire.forms';
import stripe from './twire.stripe';

export default {

	util:	util,
	forms:	forms,
	stripe:	stripe,
	init: 	function() {
		
		var _self = this;
	
		// Pseudo form
		$('div.twire-pseudo-form').each(function() {

			var $this = $(this);

			// Add the form tag
			var $form = $this.wrap('<form></form>')
			                 .closest('form');

			// Add the attributes
			var attributes = $this.prop('attributes');

			// Copy over attributes
			$.each(attributes, function() {
				
			    $form.attr(this.name, this.value);
				
			});
			
			// Copy method and action and remove data- counterparts
			$form.attr('method', $this.data('method'));
			$form.attr('action', $this.data('action'));
			$form.attr('data-method', null);
			$form.attr('data-action', null);

			// Get rid of the dummy tag
			$this.replaceWith($this.children());
							 
		});
		
		// Set time and GUID for all forms so they work with caching
		$('form.twire-validated-form').each(function() {
			
			var $form 			= $(this);
			
			var unixTimestamp 	= _self.util.getUNIXTimestamp();
			var guid 			= _self.util.generateGUID();
		
			$form.find('input[name="twire-t"]').val(unixTimestamp);
			$form.find('input[name="twire-guid"]').val(guid);
		
		});
		
		// Deferred images
		$(window).on('load.twire.twire-core', function() {
			
			// data-twire-src
			$('*[data-twire-src]').each(function() {
			
				var $el = $(this);
				
				$el.attr('src', $el.data('twire-src'));
			
			});
			
			// data-twire-bg
			$('*[data-twire-bg]').each(function() {
			
				var $el = $(this);
				
				$el.css('background-image', 'url(' + $el.data('twire-bg') + ')');
			
			});
			
		});
		

		// data-twire-pseudo-link
		$('*[data-twire-pseudo-link]').on('click.twire.twire-core', function() {

			window.location = $(this).data('twire-pseudo-link');

		});


		// Clone
		$('*[data-twire-clone]').each(function() {

			var $this		= $(this);
			var selector 	= $this.data('twire-clone');
			var $target 	= $(selector);

			if ($target.length) {

				$this.replaceWith($target.clone());

			}

		});


		// Videos
		window.twireReflowVideo = function($iframe) {

			if ($iframe.data('twire-video-aspect-ratio') && ($iframe.prop('tagName').toLowerCase() == 'iframe' || $iframe.prop('tagName').toLowerCase() == 'video')) {

				var dimensions 	= $iframe.data('twire-video-aspect-ratio');
				dimensions 		= dimensions.split(':');

				var newHeight 	= ($iframe.width() / dimensions[0]) * dimensions[1];
				newHeight		= parseInt(newHeight);

				$iframe.css('height', newHeight + 'px');

			}

		};

		window.twireReflowVideos = function() {

			$('iframe, video').each(function() {

				window.twireReflowVideo($(this));

			});

		}

		$(window).on('resize.twire.twire-core', function() {

			window.twireReflowVideos();

		}).trigger('resize');


		// Trigger window load after a time
		// (in case third-party scripts delay event and therefore local scripts that reply in window loaded)
		// Defaults to 5 seconds, can be overridden using body[data-loaded-handler-timeout]
		// Set to 0 to disable
		window.twireLoadedHandlerCalled = false;

		var loadedHandlerTimeout = typeof $('body').data('twire-loaded-handler-timeout') == 'undefined' ? 5000 : parseInt($('body').data('twire-loaded-handler-timeout'));

		if (loadedHandlerTimeout != 0) {

			$(window).on('load.twire.twire-core', function() {
			     
			    window.twireLoadedHandlerCalled = true;
			     
			});
			 
			setTimeout(function() {
			     
			    if (window.twireLoadedHandlerCalled === false) {
			 
			         window.dispatchEvent(new Event('load'));
			        
			    }
			 
			}, loadedHandlerTimeout);

		}	
		
		// Init forms
		_self.forms.addValidationHandler();
		
	}

};
